import { render, staticRenderFns } from "./prize_steps_modal.vue?vue&type=template&id=083c420c&"
import script from "./prize_steps_modal.vue?vue&type=script&lang=js&"
export * from "./prize_steps_modal.vue?vue&type=script&lang=js&"
import style0 from "./prize_steps_modal.vue?vue&type=style&index=0&id=083c420c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports